<div class="row">
  <div class="col">
    <div class="row vdivide" *ngIf="!responseReceived">
      <div class="col">
        <form class="form-box login-form form-validator" (ngSubmit)="onSubmit()" #f="ngForm">
          <h6 class="text-primary" style="font-weight: 400">Please enter your account email address.</h6>
          <p>
            Your will be able to reset your password through a link sent to your email address we have on file for you.
          </p>

          <div class="form-group label-floating is-empty">
            <label class="control-label">Enter Email<span class="required">*</span></label>

            <input
              type="email"
              class="form-control {{ submitted && !email.valid ? 'ng-invalid ng-touched' : '' }}"
              [(ngModel)]="emailAddress"
              name="email"
              email
              required
              #email="ngModel"
            />

            <span class="material-input"></span>
            <span class="help-block invalidEntry" *ngIf="(!email.valid && email.touched) || (submitted && !email.valid)"
              >Please enter a valid email.</span
            >
          </div>
          <div class="form-group label-floating is-empty">
            <re-captcha (resolved)="resolved($event)" siteKey="6LfCKnQdAAAAAKiURz604zMfG7Wysft_djYvXsLC"></re-captcha>

            <span class="material-input"></span>
            <span class="help-block invalidEntry" *ngIf="submitted && !captcha">Captcha is required.</span>
          </div>
          <div class="buttons-box clearfix">
            <button class="btn btn-primary btn-raised btn-block">Submit</button><br />
          </div>
        </form>
        <!-- .form-box -->
      </div>
    </div>

    <div *ngIf="responseReceived">
      <h2>Forgot Password</h2>
      <div class="lf-secondaryText">
        Instructions regarding resetting your password have been sent to your email address:
      </div>
      <div>{{ emailAddress }}</div>
      <div>
        If no email arrives within ten minutes, check that the submitted address is correct. Alternatively, you may want
        to
        <span class="text-info">create a new account</span>.
      </div>
    </div>
  </div>
</div>
